import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { format, parse } from 'date-fns';
import { TextField } from '../TextField/TextField';
/**
 *
 * For RHF validation ensure you use the RHFRules "timePicker" option exported from sour-ui RHFRules
 */
export const TimePicker = ({ value, onChange, ...props }) => {
    const [time, setTime] = useState('');
    const isValidDate = (date) => {
        return date.toString() !== 'Invalid Date';
    };
    const handleChange = (e) => {
        // Remove all non-digit characters except for AM/PM
        const { value } = e.target;
        const cleanedInput = value.replace(/[^0-9:\sAPM]/gi, '');
        const parts = cleanedInput.match(/(\d{1,2}):?(\d{0,2})?\s*(AM|PM)?/i);
        let [, hours, minutes, period] = parts || [];
        // Need this so undefined doesn't show
        hours = hours || '';
        minutes = minutes || '';
        period = period || '';
        // Add leading zero if the first digit is greater than 1
        if (hours && hours.length === 1 && parseInt(hours) > 2) {
            hours = '0' + hours;
        }
        // Various automation, such as military time, if gte than 24, assume hours + minutes are being typed
        if (hours && hours.length >= 2) {
            const hoursNum = parseInt(hours);
            if (hoursNum >= 24) {
                minutes = parseInt(hours.slice(1, 2)) >= 6 ? '' : hours.slice(1, 2);
                hours = '0' + hours.slice(0, 1);
            }
            else if (hoursNum > 12 && minutes.length === 2) {
                hours = hoursNum - 12 > 9 ? (hoursNum - 12).toString() : '0' + (hoursNum - 12);
                period = 'PM';
            }
            else if (hoursNum === 0 && minutes.length === 2) {
                hours = '12';
                period = 'AM';
            }
        }
        // If the first digit of minutes > 5, clear it
        if (minutes && minutes.length === 1 && parseInt(minutes) > 5) {
            minutes = '';
        }
        let formattedTime = cleanedInput;
        if (hours && hours.length === 2) {
            if (minutes && minutes.length === 2) {
                formattedTime = `${hours}:${minutes} `;
                const lastChar = cleanedInput[cleanedInput.length - 1].toUpperCase();
                // If the last character is 'A', set the period to 'AM'
                if (lastChar === 'A') {
                    period = 'AM';
                }
                // If the last character is 'P', set the period to 'PM'
                else if (lastChar === 'P') {
                    period = 'PM';
                }
                formattedTime += period;
            }
            else {
                formattedTime = `${hours}:${minutes}`;
            }
        }
        setTime(formattedTime);
    };
    useEffect(() => {
        if (value === 'error')
            return;
        if (value === null || value === undefined || value === '') {
            setTime('');
        }
        else {
            try {
                const stringTime = format(new Date(value), 'hh:mm aa');
                setTime(stringTime);
            }
            catch (error) {
                setTime('');
            }
        }
    }, [value]);
    useEffect(() => {
        if (time) {
            const date = parse(time, 'hh:mm aa', value && value !== 'error' ? value : new Date());
            if (date && isValidDate(date)) {
                onChange(date);
            }
            else {
                onChange('error');
            }
        }
        if (!time && value !== '')
            onChange('');
    }, [time]);
    return (_jsx(TextField, { inputProps: { value: time, onChange: handleChange, maxLength: 8, ...props.inputProps }, endAdornment: _jsx(XMarkIcon, { className: "size-4", onClick: () => setTime('') }), ...props }));
};
//# sourceMappingURL=TimePicker.js.map